import React from 'react';
import { Card, CardContent } from '../../../../components/ui/Card';
import AppIcon from '../../../../components/AppIcon';

interface MetricCardProps {
  title: string;
  value: string | number;
  subtitle?: string;
  description?: string;
  icon: string;
  iconColor?: string;
  trend?: {
    type: 'up' | 'down' | 'stable';
  };
}

const MetricCard: React.FC<MetricCardProps> = ({
  title,
  value,
  subtitle,
  description,
  icon,
  iconColor = 'text-primary',
  trend,
}) => {
  return (
    <Card className="h-full">
      <CardContent>
        <div className="flex items-start justify-between">
          <div className="flex-1">
            <p className="text-xs text-muted-foreground">{title}</p>
            <div className="flex items-baseline gap-1 mt-1">
              <span className="text-2xl font-bold text-foreground">{value}</span>
              {trend?.type === 'up' && (
                <AppIcon name="TrendingUp" size={14} className="text-emerald-500" />
              )}
              {trend?.type === 'down' && (
                <AppIcon name="TrendingDown" size={14} className="text-red-500" />
              )}
              {trend?.type === 'stable' && (
                <AppIcon name="Minus" size={14} className="text-muted-foreground" />
              )}
            </div>
            {subtitle && (
              <p className="text-xs text-muted-foreground mt-1">{subtitle}</p>
            )}
            {description && (
              <p className="text-xs text-muted-foreground mt-0.5">{description}</p>
            )}
          </div>
          <div className="w-12 h-12 rounded-lg bg-muted flex items-center justify-center shrink-0 ms-2">
            <AppIcon name={icon} size={24} className={iconColor} />
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default MetricCard;
